/* eslint-disable-next-line no-magic-numbers */
export const PAGE_SIZES = [25, 50, 75, 100];
export const FIELD_CHANGE_DEBOUNCE_DELAY = 500;
export const SESSIONS_TABLE_VERSION = 1.52;
export const SESSIONS_TABLE_STORE_KEY = 'sessions-table';
